import { ReactElement } from "react";

import { FilterAddButton, FilterClearButton } from "./";
import {
  FilterActionsDividerStyled,
  FilterActionsStyled,
} from "./actions.styled";

export const FiltersActions = (): ReactElement => {
  return (
    <FilterActionsStyled>
      <FilterAddButton />
      <FilterActionsDividerStyled />
      <FilterClearButton />
    </FilterActionsStyled>
  );
};
